// import i18n from "../i18n";
// import store from "../store";
// import { Notification } from "element-ui";
function errorResponseHandler(res) {
}
export default errorResponseHandler;
